import httpService from "@/helper/httpService";
import { productKeyFromCategories } from "@/helper/praemienHelper";
import iban from "iban";
import bic from "bic";

export const loginNameRule = {
  getMessage() {
    return "Der Anmeldename ist nicht verfügbar.";
  },
  validate(value) {
    var negreg = new RegExp("^dmb.*$|^bi_.*$", "i");
    if (negreg.test(value)) {
      return false;
    }
    return httpService.checkUserName(value)
      .then(response => response.available)
      // TODO true or false for error? different message?
      .catch(() => false);
  }
};

export const allowedCategoriesRule = {
  getMessage() {
    return "Ungültige Kombination für ihren Tarif.";
  },
  validate(value, args) {
    if (!args || !args[0]) {
      return true;
    }
    const tarif = args[0];
    const productKey = productKeyFromCategories(value);
    switch (tarif) {
      case "comfortplan":
        return ["PBVW", "PBW", "PVW", "PBV"].includes(productKey);
      case "securo":
        return ["PBVW", "PBV", "V"].includes(productKey);
      case "securoplus":
        return productKey !== "P";
      case "securopremium":
        return ["PBVW", "PVW", "PBV"].includes(productKey);
      default:
        return true;
    }
  }
};

export const emailDeVRule = {
  /* \u00C0-\u00FF are the letters from Latin-1 Supplement  https://www.lookuptables.com/text/unicode-characters */
  getMessage: () => 'Format der E-Mail ist nicht gültig!',
  validate: function(address) {
		const pattern = /^[a-zA-Z0-9]+([-_+.][a-zA-Z0-9]+)*@[a-zA-Z0-9\u00C0-\u00FF-]+([.][a-zA-Z0-9-]+)*\.[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*$/;

		if (address && address.trim() !== "" && address.length <= 241) {
			const atSplit = address.split('@');

			if (atSplit.length === 2 && atSplit[0].length <= 63) {
				const domainParts = atSplit[1].split('.');

				if (domainParts.length >= 2 && domainParts[domainParts.length - 1].length >= 2) {
					if (pattern.test(address)) {
						return true;
					}
				}
			}
		}
		return false;
	}
};

export const truthyRule = {
  getMessage: field => field + ' ist ein Pflichtfeld.',
  validate: value => !!value
};

export const ibanRule = (value) => {
  return iban.isValid(value.replace(/ /g,""));
};

export const bicRule = (value) => {
  return bic.isValid(value);
};